import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { IUrlUtils } from 'v2/modules/lib'

export interface IQn2cServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

export const makeQn2cService = ({ httpClient, urlUtils }: IQn2cServiceArgs) => {
  const verifyQn2cToken = async (token: string): Promise<Record<string, any>> => {
    const res = await httpClient.post(
      '/qn2c-service/token/verify',
      { jwt: token },
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const qn2cBlockAction = async (token: string): Promise<Record<string, any>> => {
    const res = await httpClient.patch(
      '/qn2c-service/block',
      { jwt: token },
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const qn2cDeliverAction = async (token: string): Promise<Record<string, any>> => {
    const res = await httpClient.post(
      '/qn2c-service/deliver',
      { jwt: token },
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const qn2cAllowAction = async (token: string): Promise<Record<string, any>> => {
    const res = await httpClient.patch(
      '/qn2c-service/allow',
      { jwt: token },
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  return Object.freeze({
    verifyQn2cToken,
    qn2cBlockAction,
    qn2cDeliverAction,
    qn2cAllowAction
  })
}
